<script lang="ts">
	import '../app.css';
	import { theme } from '$lib/stores/theme';
	import DebugScreens from '$lib/components/DebugScreens.svelte';
	import Header from '$lib/components/Header.svelte';

	theme.init();
</script>

<svelte:head>
	<link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
	<link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
	<link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
	<link rel="manifest" href="/site.webmanifest" />
</svelte:head>

<div class="w-screen overflow-x-hidden min-h-screen grid grid-cols-1 grid-rows-[min-content_auto] gap-4">
	<Header />
	<div class="container px-4 mx-auto">
		<slot />
	</div>
</div>

<DebugScreens />
